export default {"src":"/_next/static/media/logo-black.a49b7428.svg","height":400,"width":1496,"blurWidth":0,"blurHeight":0};